module.exports = __webpack_public_path__ + "img/forgetPass3.cac88393.png";